import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm$user, _vm$user$limitedLocat, _vm$addingLimitedLoca;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_vm.isFromList ? _c("return", {
    ref: "return",
    attrs: {
      routeName: "adminUserList"
    }
  }) : _vm._e(), !_vm.isAuthorized ? _c("div", [_c("h1", [_vm._v("Oups !")]), _c("p", [_vm._v("It seems something went wrong !")])]) : _vm.isLoaded ? _c("div", {
    staticClass: "container-centered"
  }, [_vm.canManage ? [_vm.isDeleted ? _c("div", {
    staticClass: "errorLabel text-center"
  }, [_vm._v("This user has been deleted")]) : [_c("div", {
    staticClass: "profile-configurations"
  }, [_vm.user.isSubscriptionPendingActivation ? _c("section", [_c("h2", [_c(VIcon, {
    attrs: {
      color: "blue"
    }
  }, [_vm._v("fa-clock")]), _vm._v(" Pending Subscription ")], 1), _c("p", {
    staticClass: "mt-3 text-left"
  }, [_vm._v(" This user has submitted a new subscription request and is awaiting administrator approval. ")]), _c("div", {
    staticClass: "flex items-start --column gap-3"
  }, [_c("div", {
    staticClass: "flex gap-2"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: true,
      loading: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.acceptUserSubscription(true);
      }
    }
  }, [_vm._v(" Approve & Notify User ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: true,
      loading: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.acceptUserSubscription(false);
      }
    }
  }, [_vm._v(" Approve Silently ")])], 1), _c("div", {
    staticClass: "flex gap-2"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 red-highlight",
    attrs: {
      rounded: true,
      loading: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.declineUserSubscription(true);
      }
    }
  }, [_vm._v(" Decline & Notify User ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: true,
      loading: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.declineUserSubscription(false);
      }
    }
  }, [_vm._v(" Decline Silently ")])], 1)])]) : _vm.isUserSubscriptionStatusDeclined ? _c("section", [_c("h2", [_c(VIcon, {
    attrs: {
      color: "red"
    }
  }, [_vm._v("fa-ban")]), _vm._v(" Declined Subscription ")], 1), _vm._m(0), _c("div", {
    staticClass: "mt-3 text-left"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: true,
      loading: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.resetSubscriptionStatus();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-undo mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Return to pending subscription status ")], 1)], 1)]) : _c("section", [_c("h2", [_vm._v("Activation Status")]), _c(VCheckbox, {
    attrs: {
      label: "Activated",
      disabled: !_vm.isAdding,
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        _vm.user.active ? _vm.user.archive = false : null;
      }
    },
    model: {
      value: _vm.user.active,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "active", $$v);
      },
      expression: "user.active"
    }
  }), !_vm.isAdding && !_vm.user.archive ? _c("div", {
    staticClass: "flex gap-2"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2",
    class: _vm.user.active ? "red-highlight" : "highlight",
    attrs: {
      rounded: true,
      loading: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        _vm.user.active ? _vm.deactivateUser(true) : _vm.activateUser(true);
      }
    }
  }, [_vm._v(" " + _vm._s(!_vm.user.active ? "Activate user with notification" : "Deactivate user with notification") + " ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: true,
      loading: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        _vm.user.active ? _vm.deactivateUser() : _vm.activateUser();
      }
    }
  }, [_vm._v(" " + _vm._s(!_vm.user.active ? "Activate user without notification" : "Deactivate user without notification") + " ")])], 1) : _vm._e(), !_vm.isAdding && !_vm.user.active ? _c("div", [_c(VCheckbox, {
    attrs: {
      label: "Archived",
      "hide-details": "auto",
      disabled: _vm.isAnyActionInProgress
    },
    model: {
      value: _vm.user.archive,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "archive", $$v);
      },
      expression: "user.archive"
    }
  })], 1) : _vm._e()], 1), _c("section", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isSuperAdmin(_vm.loggedUserData),
      expression: "isSuperAdmin(loggedUserData)"
    }]
  }, [_c("h2", [_vm._v("Options")]), _c("div", [_c("div", {
    staticClass: "flex gap-2 mb-1"
  }, [_c(VCheckbox, {
    staticClass: "v-text-field-no-label",
    attrs: {
      disabled: !_vm.isFamilyFriendsAvailable,
      label: "Family & Friends",
      "hide-details": "auto"
    },
    model: {
      value: _vm.user.isFamilyFriends,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "isFamilyFriends", $$v);
      },
      expression: "user.isFamilyFriends"
    }
  }), _vm.user.isFamilyFriends && _vm.canGetCommissions() ? _c("div", {
    staticClass: "text-sm text-italic mt-1 text-left"
  }, [_vm._v(" The default commission will be " + _vm._s(_vm.familyFriendsCommission) + "% for this user. ")]) : _vm._e()], 1), _c(VCheckbox, {
    staticClass: "v-text-field-no-label",
    attrs: {
      label: "Bypass buy limitations",
      disabled: !_vm.isBuyerGroup(_vm.user.user_group) && !_vm.user.isHolding,
      "hide-details": "auto"
    },
    model: {
      value: _vm.user.has_bypass_buy_limit,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "has_bypass_buy_limit", $$v);
      },
      expression: "user.has_bypass_buy_limit"
    }
  }), _c(VCheckbox, {
    staticClass: "v-text-field-no-label mt-1",
    attrs: {
      label: "Prevent auto notifications about late payments",
      "hide-details": "auto"
    },
    model: {
      value: _vm.user.isPreventedFromPaymentLateNotifications,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "isPreventedFromPaymentLateNotifications", $$v);
      },
      expression: "user.isPreventedFromPaymentLateNotifications"
    }
  }), _c(VCheckbox, {
    staticClass: "v-text-field-no-label mt-1",
    attrs: {
      label: "Allowed to order without payment",
      disabled: !_vm.isBuyerGroup(_vm.user.user_group) && !_vm.isUserConsultantOrHolding,
      "hide-details": "auto"
    },
    model: {
      value: _vm.user.is_allowed_order_without_payment,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "is_allowed_order_without_payment", $$v);
      },
      expression: "user.is_allowed_order_without_payment"
    }
  }), _vm.isUserCorporate ? _c(VCheckbox, {
    staticClass: "v-text-field-no-label mt-1",
    attrs: {
      readonly: "",
      label: "Allowed to dispatch to any customer (OLD InboundDeliveries)",
      "hide-details": "auto"
    },
    model: {
      value: _vm.user.isAllowedToDispatchToAnyone,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "isAllowedToDispatchToAnyone", $$v);
      },
      expression: "user.isAllowedToDispatchToAnyone"
    }
  }) : _vm._e()], 1)])])]] : _vm._e(), _vm.isConsultantOrHolding(_vm.loggedUserData) && !_vm.user.active ? _c("div", {
    staticClass: "errorLabel"
  }, [_vm._v(" User deactivated ")]) : _vm._e(), _c("div", {
    staticClass: "profile-container"
  }, [_c("section", [_c("h2", [_vm._v("Personal information")]), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Login",
      "hide-details": "auto",
      placeholder: "john.doe@domain.com",
      readonly: _vm.readOnly
    },
    model: {
      value: _vm.user.login,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "login", $$v);
      },
      expression: "user.login"
    }
  }), _vm.errorLabels.login.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.login) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "First name",
      "hide-details": "auto",
      placeholder: "John",
      readonly: _vm.readOnly
    },
    model: {
      value: _vm.user.name,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "name", $$v);
      },
      expression: "user.name"
    }
  }), _vm.errorLabels.name.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.name) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Last name",
      "hide-details": "auto",
      placeholder: "Doe",
      readonly: _vm.readOnly
    },
    model: {
      value: _vm.user.nickname,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "nickname", $$v);
      },
      expression: "user.nickname"
    }
  }), _vm.errorLabels.nickname.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.nickname) + " ")]) : _vm._e()], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isUserIndividual,
      expression: "!isUserIndividual"
    }]
  }, [_c(VTextField, {
    class: _vm.isUserHorecaOrWholesaler || _vm.user.isHolding ? "required" : "",
    attrs: {
      label: "Company name",
      "hide-details": "auto",
      placeholder: "Company name",
      readonly: _vm.readOnly
    },
    model: {
      value: _vm.user.company_name,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "company_name", $$v);
      },
      expression: "user.company_name"
    }
  }), _vm.errorLabels.company_name.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.company_name) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Phone number",
      "hide-details": "auto",
      placeholder: "+33686868686",
      readonly: _vm.readOnly
    },
    model: {
      value: _vm.user.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "phone", $$v);
      },
      expression: "user.phone"
    }
  }), _vm.errorLabels.phone.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.phone) + " ")]) : _vm._e()], 1), !_vm.isAdding ? _c("div", {
    staticClass: "text-sm text-left text-italic"
  }, [_vm._v(" Created on " + _vm._s(_vm._f("formatDate")(_vm.user.creationDate)) + " ")]) : _vm._e(), ((_vm$user = _vm.user) === null || _vm$user === void 0 || (_vm$user = _vm$user.userSignUpLink) === null || _vm$user === void 0 ? void 0 : _vm$user.id) > 0 ? _c("div", {
    staticClass: "text-sm text-left text-italic"
  }, [_vm._v(" Origin: " + _vm._s(_vm.user.userSignUpLink.utmSource) + " ")]) : _vm._e()]), _c("section", [_c("h2", [_vm._v("Additional information")]), _c("div", [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      label: "User group",
      items: _vm.listUserGroupsAvailable,
      "item-value": "id",
      "item-text": "name",
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto",
      readonly: !!_vm.user.id_user && !_vm.canEditExistingUserGroup || _vm.readOnly || _vm.isHolding(_vm.loggedUserData)
    },
    on: {
      change: function change($event) {
        return _vm.changeUserGroup();
      }
    },
    model: {
      value: _vm.user.user_group,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "user_group", $$v);
      },
      expression: "user.user_group"
    }
  }), _vm.errorLabels.user_group.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.user_group) + " ")]) : _vm._e()], 1), _vm.user.user_group == "ADMIN" ? _c("div", [_c(VAutocomplete, {
    attrs: {
      label: "Admin type",
      items: [{
        id: "ADMIN",
        name: "Type : Administrator"
      }, {
        id: "CONSULTANT",
        name: "Type : Consultant"
      }, {
        id: "CONSULTANT_HOLDING",
        name: "Type : Corporate"
      }, {
        id: "SALESMAN",
        name: "Type : Salesperson"
      }],
      "item-value": "id",
      "item-text": "name",
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto",
      readonly: !!_vm.user.id_user || _vm.readOnly
    },
    on: {
      change: function change($event) {
        return _vm.verifyFactoringProvider();
      }
    },
    model: {
      value: _vm.user.user_sub_group,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "user_sub_group", $$v);
      },
      expression: "user.user_sub_group"
    }
  })], 1) : _vm._e(), _vm.isBuyerGroup(_vm.user.user_group) && _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("div", [_c(VAutocomplete, {
    attrs: {
      label: "Salesperson",
      items: _vm.listSalesman,
      "item-value": "id_user",
      "item-text": "fullname",
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto",
      readonly: !_vm.canChangeSalesmanFollower || _vm.isDeleted
    },
    model: {
      value: _vm.user.salesman_follower.id_user,
      callback: function callback($$v) {
        _vm.$set(_vm.user.salesman_follower, "id_user", $$v);
      },
      expression: "user.salesman_follower.id_user"
    }
  })], 1) : _vm._e(), _vm.isUserConsultantOrHolding ? _c("div", [_c("div", {
    staticClass: "consultant-container"
  }, [_c(VTextField, {
    attrs: {
      label: "Consultant code",
      "hide-details": "auto",
      readonly: _vm.readOnly || _vm.isConsultantOrHolding(_vm.loggedUserData)
    },
    model: {
      value: _vm.user.consultant_code,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "consultant_code", $$v);
      },
      expression: "user.consultant_code"
    }
  }), _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c(VTooltip, {
    attrs: {
      top: ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VBtn, _vm._g(_vm._b({
          attrs: {
            icon: "",
            color: "black"
          },
          on: {
            click: _vm.generateConsultanteCode
          }
        }, "v-btn", attrs, false), on), [_c(VIcon, [_vm._v("fa fa-grin-stars")])], 1)];
      }
    }], null, false, 174743440)
  }, [_vm._v(" Generate consultant code ")]) : _vm._e()], 1), _vm.errorLabels.consultant_code.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.consultant_code) + " ")]) : _vm._e()]) : _vm._e(), !_vm.isUserAdminNotConsultant ? _c("div", [_c("div", {
    staticClass: "flex"
  }, [_vm.isAdminNotConsultant(_vm.loggedUserData) ? _c(VCombobox, {
    attrs: {
      label: !_vm.isUserConsultantOrHolding ? "Keypass" : "Keypass, copy the consultant code here to apply commission to his orders",
      items: _vm.gettingConsultants.items,
      "item-text": "displayName",
      clearable: "",
      "hide-details": "auto",
      readonly: _vm.readOnly || _vm.isConsultantOrHolding(_vm.loggedUserData),
      filter: _vm.filterVAutocomplete
    },
    on: {
      change: _vm.updateSponsorshipCode,
      blur: function blur($event) {
        return _vm.getIsUserAttachedToConsultant();
      }
    },
    model: {
      value: _vm.selectedConsultant,
      callback: function callback($$v) {
        _vm.selectedConsultant = $$v;
      },
      expression: "selectedConsultant"
    }
  }) : _c(VTextField, {
    attrs: {
      label: !_vm.isUserConsultantOrHolding ? "Keypass" : "Keypass, copy the consultant code here to apply commission to his orders",
      clearable: "",
      "hide-details": "auto",
      readonly: _vm.readOnly || _vm.isConsultantOrHolding(_vm.loggedUserData)
    },
    on: {
      blur: function blur($event) {
        return _vm.getIsUserAttachedToConsultant();
      }
    },
    model: {
      value: _vm.user.sponsorship_code,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "sponsorship_code", $$v);
      },
      expression: "user.sponsorship_code"
    }
  }), _vm.isAdminNotConsultant(_vm.loggedUserData) && _vm.isUserConsultantOrHolding ? _c(VTooltip, {
    attrs: {
      top: ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c(VBtn, _vm._g(_vm._b({
          attrs: {
            icon: "",
            color: "black"
          },
          on: {
            click: function click($event) {
              return _vm.copyConsultantCode();
            }
          }
        }, "v-btn", attrs, false), on), [_c(VIcon, [_vm._v("fa fa-grin-stars")])], 1)];
      }
    }], null, false, 2473286173)
  }, [_vm._v(" Copy consultant code to apply a reward on himself ")]) : _vm._e()], 1)]) : _vm._e(), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isUserIndividual,
      expression: "!isUserIndividual"
    }]
  }, [_c(VTextField, {
    class: _vm.isUserHorecaOrWholesaler ? "required" : "",
    attrs: {
      label: _vm.taxIdLabel,
      "hide-details": "auto",
      placeholder: "FR99999999999",
      readonly: _vm.readOnly
    },
    model: {
      value: _vm.user.vat_code,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "vat_code", $$v);
      },
      expression: "user.vat_code"
    }
  }), _vm.errorLabels.vat_code.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.vat_code) + " ")]) : _vm._e()], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isUserIndividual,
      expression: "!isUserIndividual"
    }]
  }, [_c(VTextField, {
    class: (_vm.user.user_group === "HORECA" || _vm.user.user_group === "WHOLESALER") && (_vm.user.delivery_address.country.iso_code === "USA" || _vm.user.delivery_address.country.iso_code === "BRA") ? "required" : "",
    attrs: {
      label: _vm.liquorNumberLabel,
      "hide-details": "auto",
      placeholder: "FR111111111111",
      readonly: _vm.readOnly
    },
    model: {
      value: _vm.user.excise_code,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "excise_code", $$v);
      },
      expression: "user.excise_code"
    }
  })], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isUserIndividual,
      expression: "isUserIndividual"
    }]
  }, [_c(VTextField, {
    attrs: {
      label: _vm.individualCodeLabel,
      "hide-details": "auto",
      placeholder: "",
      readonly: _vm.readOnly
    },
    model: {
      value: _vm.user.individualCode,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "individualCode", $$v);
      },
      expression: "user.individualCode"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Contact additional information",
      "hide-details": "auto",
      placeholder: "Please contact me between 6 and 9pm",
      readonly: _vm.readOnly
    },
    model: {
      value: _vm.user.contact,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "contact", $$v);
      },
      expression: "user.contact"
    }
  })], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Contact email address",
      "hide-details": "auto",
      placeholder: "Your specific contact email address",
      readonly: _vm.readOnly
    },
    model: {
      value: _vm.user.contactEmail,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "contactEmail", $$v);
      },
      expression: "user.contactEmail"
    }
  }), _vm.errorLabels.contactEmail.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.contactEmail) + " ")]) : _vm._e()], 1), _c("div", [_c(VTextField, {
    attrs: {
      label: "Billing email address",
      "hide-details": "auto",
      placeholder: "Your specific billing email address",
      readonly: _vm.readOnly
    },
    model: {
      value: _vm.user.billingEmail,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "billingEmail", $$v);
      },
      expression: "user.billingEmail"
    }
  }), _vm.errorLabels.billingEmail.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.billingEmail) + " ")]) : _vm._e()], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.canManage,
      expression: "canManage"
    }]
  }, [_c(VTextField, {
    attrs: {
      label: "Accounting code",
      "hide-details": "auto",
      placeholder: "The customer accounting code",
      readonly: _vm.readOnly
    },
    model: {
      value: _vm.user.accountingExternalId,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "accountingExternalId", $$v);
      },
      expression: "user.accountingExternalId"
    }
  })], 1), _c("div", [_vm.isAdding ? _c(VCheckbox, {
    attrs: {
      label: "Define default payment terms",
      disabled: !_vm.isAdding,
      "hide-details": "auto"
    },
    model: {
      value: _vm.user.isDefiningPaymentTerms,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "isDefiningPaymentTerms", $$v);
      },
      expression: "user.isDefiningPaymentTerms"
    }
  }) : _vm._e(), _c(VAutocomplete, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isAdding || _vm.user.isDefiningPaymentTerms,
      expression: "!isAdding || user.isDefiningPaymentTerms"
    }],
    attrs: {
      label: "Default payment terms",
      items: _vm.paymentTerms,
      "item-value": "id",
      "item-text": "name",
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto",
      readonly: _vm.readOnly
    },
    model: {
      value: _vm.user.id_term,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "id_term", $$v);
      },
      expression: "user.id_term"
    }
  }), _vm.errorLabels.id_term.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.id_term) + " ")]) : _vm._e()], 1), !!_vm.user.id_user || _vm.canChangeCurrency ? _c("div", [_c(VAutocomplete, {
    attrs: {
      label: "Default currency",
      items: _vm.listDefaultCurrencies,
      "item-value": "id",
      "item-text": "name",
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto",
      readonly: _vm.readOnly || !_vm.canChangeCurrency
    },
    on: {
      change: function change($event) {
        return _vm.verifyFactoringProvider();
      }
    },
    model: {
      value: _vm.user.default_currency,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "default_currency", $$v);
      },
      expression: "user.default_currency"
    }
  })], 1) : _vm._e(), _vm.isAdminNotConsultant(_vm.loggedUserData) || _vm.getFactoryProviders.length > 1 ? _c("div", [_c(VAutocomplete, {
    attrs: {
      label: "Financing option",
      items: _vm.getFactoryProviders,
      "item-value": "id",
      "item-text": "name",
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto",
      readonly: _vm.readOnly || !_vm.canManageFactoringProviders || _vm.getFactoryProviders.length == 1
    },
    model: {
      value: _vm.user.factoring_provider.id,
      callback: function callback($$v) {
        _vm.$set(_vm.user.factoring_provider, "id", $$v);
      },
      expression: "user.factoring_provider.id"
    }
  })], 1) : _vm._e(), _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("div", [_c(VAutocomplete, {
    attrs: {
      label: "Grant access to",
      items: _vm.rangeAccess,
      "item-value": "id",
      "item-text": "displayGrantAccess",
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto",
      clearable: "",
      readonly: _vm.readOnly
    },
    model: {
      value: _vm.user.rangeAccessibility,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "rangeAccessibility", $$v);
      },
      expression: "user.rangeAccessibility"
    }
  })], 1) : _vm._e(), _vm.isAdminNotConsultant(_vm.loggedUserData) && _vm.isUserConsultantOrHolding && _vm.user.rangeAccessibility ? _c("div", {
    staticClass: "text-italic text-sm"
  }, [_vm._v(" This configuration will be applied to all the associated users ")]) : _vm._e(), _vm.isAdminNotConsultant(_vm.loggedUserData) && _vm.isUserAssociatedToConsultant ? _c("div", {
    staticClass: "text-italic text-sm text-left mt-0"
  }, [_vm._v(" " + _vm._s(_vm.user.rangeAccessibility ? "Clear granted access configuration to automatically apply the attached consultant/corporate granted access configuration" : "Attached Consultant/corporate granted access configuration will be applied") + " ")]) : _vm._e()])]), _vm.canManageLimitedLocations ? _c("div", {
    staticClass: "profile-container mt-8"
  }, [_c("section", {
    staticClass: "text-left"
  }, [_c("h2", [_vm._v("Limit access locations")]), ((_vm$user$limitedLocat = _vm.user.limitedLocations) === null || _vm$user$limitedLocat === void 0 ? void 0 : _vm$user$limitedLocat.length) > 0 ? _c("div", {
    staticClass: "flex --column align-start gap-1"
  }, _vm._l(_vm.user.limitedLocations, function (location) {
    var _location$state;
    return _c("div", {
      staticClass: "d-flex"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary mr-3",
      attrs: {
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.removeLimitedLocation(location);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-trash mr-1",
      attrs: {
        size: "0.655rem"
      }
    }), _vm._v(" Remove ")], 1), _c("span", [_vm._v(_vm._s(location.country.printable_name))]), (_location$state = location.state) !== null && _location$state !== void 0 && _location$state.state_label ? _c("span", [_vm._v(", " + _vm._s(location.state.state_label))]) : _vm._e()], 1);
  }), 0) : _c("div", [_vm._v("No restriction")]), !_vm.addingLimitedLocation.isConfiguring ? _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.startAddingLimitedLocation
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add a country ")], 1)], 1) : _c("div", {
    staticClass: "subform-bordered"
  }, [_c("div", [_vm._v("Add an allowed location")]), _c(VAutocomplete, {
    attrs: {
      label: "Country allowed",
      items: _vm.listCountries,
      "item-value": "id_country",
      "item-text": "printable_name",
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.resetAddingLimitedLocationStates();
      }
    },
    model: {
      value: _vm.addingLimitedLocation.form.countryId,
      callback: function callback($$v) {
        _vm.$set(_vm.addingLimitedLocation.form, "countryId", $$v);
      },
      expression: "addingLimitedLocation.form.countryId"
    }
  }), ((_vm$addingLimitedLoca = _vm.addingLimitedLocation.availableStates) === null || _vm$addingLimitedLoca === void 0 ? void 0 : _vm$addingLimitedLoca.length) > 0 ? _c(VAutocomplete, {
    attrs: {
      label: "State",
      items: _vm.addingLimitedLocation.availableStates,
      "item-value": "id_state",
      "item-text": "state_label",
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.addingLimitedLocation.form.stateId,
      callback: function callback($$v) {
        _vm.$set(_vm.addingLimitedLocation.form, "stateId", $$v);
      },
      expression: "addingLimitedLocation.form.stateId"
    }
  }) : _vm._e(), _c("div", {
    staticClass: "flex mt-2"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        _vm.addingLimitedLocation.isConfiguring = false;
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.addLimitedLocation
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add ")], 1)], 1)], 1)])]) : _vm._e(), _c("div", {
    staticClass: "profile-container mt-8"
  }, [_c("section", [_c("h2", [_vm._v("Delivery address")]), _c("div", [_c("addressComponent", {
    ref: "addressDelivery",
    attrs: {
      baseModel: _vm.user.delivery_address,
      listCountries: _vm.listCountriesForDeliveryAddress,
      listStates: _vm.listStates,
      readOnly: _vm.readOnly,
      showDeliveryInstructions: true
    }
  })], 1)]), _c("section", [_c("h2", [_vm._v("Billing address")]), _c("div", [!_vm.hide_billing_address ? _c("addressComponent", {
    ref: "addressBilling",
    attrs: {
      baseModel: _vm.user.billing_address,
      listCountries: _vm.listCountries,
      listStates: _vm.listStates,
      readOnly: _vm.readOnly
    }
  }) : _vm._e(), _c(VCheckbox, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !(_vm.readOnly && !_vm.hide_billing_address),
      expression: "!(readOnly && !hide_billing_address)"
    }],
    attrs: {
      label: "The billing address is the same",
      readonly: _vm.readOnly
    },
    on: {
      click: function click($event) {
        _vm.user.billing_is_delivery = !_vm.user.billing_is_delivery;
      }
    },
    model: {
      value: _vm.hide_billing_address,
      callback: function callback($$v) {
        _vm.hide_billing_address = $$v;
      },
      expression: "hide_billing_address"
    }
  })], 1)])]), _vm.isAdminNotConsultant(_vm.loggedUserData) && _vm.canManage ? _c("div", {
    staticClass: "button-end-page-container"
  }, [_vm.isDeleted ? _c("div", {
    staticClass: "errorLabel text-center"
  }, [_vm._v("This user has been deleted")]) : [_vm.isAdding ? [_c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.sendUserData();
      }
    }
  }, [_vm._v(" Create user ")])] : [_vm.isBuyerGroup(_vm.user.user_group) ? _c(VBtn, {
    staticClass: "dfwa-btn secondary",
    attrs: {
      to: _vm.goToUserOrders(),
      rounded: true,
      disabled: _vm.isAnyActionInProgress
    }
  }, [_vm._v(" See orders ")]) : _vm.isUserConsultant ? _c(VBtn, {
    staticClass: "dfwa-btn secondary",
    attrs: {
      to: _vm.goToConsultantOrders(),
      rounded: true,
      disabled: _vm.isAnyActionInProgress
    }
  }, [_vm._v(" See orders ")]) : _vm._e(), _vm.hasAccessToUserRoles() ? _c(VBtn, {
    staticClass: "dfwa-btn secondary",
    attrs: {
      to: _vm.goToUserRoles(),
      rounded: true,
      disabled: _vm.isAnyActionInProgress
    }
  }, [_vm._v(" See user roles ")]) : _vm._e(), _vm.canManage && _vm.user.active ? _c(VBtn, {
    staticClass: "dfwa-btn secondary",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.resendWelcomeMail();
      }
    }
  }, [_vm._v(" Resend welcome mail ")]) : _vm._e(), _c(VBtn, {
    staticClass: "dfwa-btn secondary",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.openSendMailModal();
      }
    }
  }, [_vm._v(" Send mail ")]), _c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: _vm.sendUserData
    }
  }, [_vm._v(" Save ")])]]], 2) : _vm.isConsultantOrHolding(_vm.loggedUserData) && !_vm.readOnly ? _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: _vm.sendUserData
    }
  }, [_vm._v(" " + _vm._s(_vm.isAdding ? "Create user" : "Save") + " ")])], 1) : _vm._e()], 2) : _vm._e(), _vm.sendMailModalShown ? _c("SendMailModal", {
    ref: "SendMailModal",
    attrs: {
      user: _vm.user
    },
    on: {
      closed: _vm.closeSendMailModal
    }
  }) : _vm._e(), _c("confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "mt-3 text-left"
  }, [_vm._v(" This user's subscription request has been declined. "), _c("br"), _vm._v(" Their account is currently inactive and they cannot access the system. ")]);
}];
render._withStripped = true;
export { render, staticRenderFns };